var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 290,
    height: 50,
    viewBox: "0 0 290 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167 1H290V49H167V1Z",
    fill: "url(#paint0_linear_107_21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.639999 40L13.12 12H19.52L32.04 40H25.24L15 15.28H17.56L7.28 40H0.639999ZM6.88 34L8.6 29.08H23L24.76 34H6.88Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.945 40V12H40.305L52.225 31.76H49.385L61.105 12H66.425L66.505 40H60.425L60.385 21.32H61.505L52.145 37.04H49.225L39.665 21.32H41.025V40H34.945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4681 40L81.9481 12H88.3481L100.868 40H94.0681L83.8281 15.28H86.3881L76.1081 40H69.4681ZM75.7081 34L77.4281 29.08H91.8281L93.5881 34H75.7081Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.773 40V12H115.893C118.4 12 120.56 12.4133 122.373 13.24C124.186 14.04 125.586 15.2 126.573 16.72C127.56 18.24 128.053 20.0533 128.053 22.16C128.053 24.24 127.56 26.04 126.573 27.56C125.586 29.0533 124.186 30.2 122.373 31C120.56 31.8 118.4 32.2 115.893 32.2H107.373L110.253 29.36V40H103.773ZM121.573 40L114.573 29.84H121.493L128.573 40H121.573ZM110.253 30.08L107.373 27.04H115.533C117.533 27.04 119.026 26.6133 120.013 25.76C121 24.88 121.493 23.68 121.493 22.16C121.493 20.6133 121 19.4133 120.013 18.56C119.026 17.7067 117.533 17.28 115.533 17.28H107.373L110.253 14.2V30.08Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.507 40L141.987 12H148.387L160.907 40H154.107L143.867 15.28H146.427L136.147 40H129.507ZM135.747 34L137.467 29.08H151.867L153.627 34H135.747Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.12 39V16.28H172.16V11H196.56V16.28H187.6V39H181.12Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.007 22.28H219.487V27.32H206.007V22.28ZM206.487 33.8H221.727V39H200.047V11H221.207V16.2H206.487V33.8Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.283 39.48C238.122 39.48 236.109 39.1333 234.243 38.44C232.403 37.72 230.803 36.7067 229.443 35.4C228.083 34.0933 227.016 32.56 226.243 30.8C225.496 29.04 225.123 27.1067 225.123 25C225.123 22.8933 225.496 20.96 226.243 19.2C227.016 17.44 228.083 15.9067 229.443 14.6C230.829 13.2933 232.443 12.2933 234.283 11.6C236.123 10.88 238.136 10.52 240.323 10.52C242.749 10.52 244.936 10.9467 246.882 11.8C248.856 12.6267 250.509 13.8533 251.842 15.48L247.683 19.32C246.723 18.2267 245.656 17.4133 244.482 16.88C243.309 16.32 242.029 16.04 240.643 16.04C239.336 16.04 238.136 16.2533 237.043 16.68C235.949 17.1067 235.003 17.72 234.203 18.52C233.403 19.32 232.776 20.2667 232.323 21.36C231.896 22.4533 231.683 23.6667 231.683 25C231.683 26.3333 231.896 27.5467 232.323 28.64C232.776 29.7333 233.403 30.68 234.203 31.48C235.003 32.28 235.949 32.8933 237.043 33.32C238.136 33.7467 239.336 33.96 240.643 33.96C242.029 33.96 243.309 33.6933 244.482 33.16C245.656 32.6 246.723 31.76 247.683 30.64L251.842 34.48C250.509 36.1067 248.856 37.3467 246.882 38.2C244.936 39.0533 242.736 39.48 240.283 39.48Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M275.418 11H281.898V39H275.418V11ZM262.698 39H256.218V11H262.698V39ZM275.898 27.52H262.218V22.04H275.898V27.52Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_21",
    x1: 170.5,
    y1: 25,
    x2: 294,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49E9EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.44df43fd62ac224f6b2c780d13a9225a.svg";
export { ForwardRef as ReactComponent };